export default "__VITE_ASSET__Cj2gRe9X__"